export const PWA_OPT_OUT = 'PWA_OPT_OUT';

export default PWA_OPT_OUT;
